import type { ConnectorOauthExtraConfigProps } from "@app/lib/connector_providers_ui";
import { Input } from "@dust-tt/sparkle";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function SlackOAuthExtraConfig({
  extraConfig,
  setExtraConfig,
  setIsExtraConfigValid,
}: ConnectorOauthExtraConfigProps) {
  const { t } = useTranslation();
  useEffect(() => {
    setIsExtraConfigValid(
      !!extraConfig.client_id &&
        !!extraConfig.client_secret &&
        !!extraConfig.signing_secret
    );
  }, [extraConfig, setIsExtraConfigValid]);

  return (
    <div className="flex flex-col gap-4">
      <Input
        label={t("spaces.slackAppClientId", "Slack App Client ID")}
        message={t(
          "spaces.slackClientIdHelp",
          "The Client ID from your Slack app's, available on the Basic Information page."
        )}
        messageStatus="info"
        name="client_id"
        placeholder="1234567890.1234567890123"
        value={extraConfig.client_id ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            client_id: e.target.value,
          }));
        }}
      />
      <Input
        label={t("spaces.slackAppClientSecret", "Slack App Client Secret")}
        message={t(
          "spaces.slackClientSecretHelp",
          "The Client Secret from your Slack app's, available on the Basic Information page."
        )}
        messageStatus="info"
        name="client_secret"
        placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        value={extraConfig.client_secret ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            client_secret: e.target.value,
          }));
        }}
      />
      <Input
        label={t("spaces.slackAppSigningSecret", "Slack App Signing Secret")}
        message={t(
          "spaces.slackSigningSecretHelp",
          "The Signing Secret from your Slack app's, available on the Basic Information page."
        )}
        messageStatus="info"
        name="signing_secret"
        placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        value={extraConfig.signing_secret ?? ""}
        onChange={(e) => {
          setExtraConfig((prev: Record<string, string>) => ({
            ...prev,
            signing_secret: e.target.value,
          }));
        }}
      />
    </div>
  );
}
